import { render } from "./BlocksProductsSummary.vue?vue&type=template&id=437fb2b2&scoped=true"
import script from "./BlocksProductsSummary.vue?vue&type=script&lang=js"
export * from "./BlocksProductsSummary.vue?vue&type=script&lang=js"

import "./BlocksProductsSummary.vue?vue&type=style&index=0&id=437fb2b2&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437fb2b2"]])

export default __exports__